/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */

import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import './App.css';
import Routers from './router/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import TableContextProvider from './contexts/tableContext';
import { getCookies, setCookies } from './hooks/useCookies';
import envValues from './enviornment';
import { firebaseInit } from './firebaseInit';

function App() {
  const [showBanner, setShowBanner] = useState(true);
  const [firebaseReady, setFirebaseReady] = useState(false);

  const cookieBannerControl = () => {
    setShowBanner(!showBanner);
    setCookies('showCookieBanner', false);
  };

  // Initialize Firebase once when app starts
  useEffect(() => {
    firebaseInit(envValues.FIREBASE_CONFIG)
      .then((result) => {
        if (result.success) {
          setFirebaseReady(true);
          // eslint-disable-next-line no-console
          console.log('Firebase initialized:', result.data);
        } else {
          // eslint-disable-next-line no-console
          console.error('Firebase initialization failed');
          setFirebaseReady(true); // Still allow app to load
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Firebase initialization error:', error);
        setFirebaseReady(true); // Still allow app to load
      });
  }, []); // Empty dependency array - runs only once

  return (
    <Provider store={store}>
      <div className="App">
        <TableContextProvider>
          {firebaseReady ? (
            <Routers />
          ) : (
            <div style={{ textAlign: 'center', marginTop: '50vh' }}>Loading...</div>
          )}
        </TableContextProvider>
        <ToastContainer autoClose={2000} hideProgressBar={false} />
      </div>
      {/* {showBanner &&
      envValues.REACT_APP_SHOW_COOKIE_BOX &&
      getCookies('showCookieBanner') !== 'false' ? (
        <div className="cookie-banner">
          <p>
            We use cookies to enhance your experience on our website. By logging in, you agree to
            our use of cookies for essential functionality and performance. For more details, please
            see our{' '}
            <a href="/privacypolicy">
              <p>[Privacy policy]</p>
            </a>
            .
          </p>
          <button type="button" className="close" onClick={cookieBannerControl}>
            I Understand
          </button>
        </div>
      ) : null} */}
    </Provider>
  );
}
export default App;
